import { FC } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet, useParams } from 'react-router-dom'
import { PublicRoutes } from '../constants/routes'
import { IConfigSeller } from '../models/configSeller'
import { IUser } from '../models/user.model'

interface IOwnProps{
  roles: Array<number>
}

const AuthRoleRouterGuard: FC<IOwnProps> = ({ roles }) => {
  const userState = useSelector((store: { user: IUser }) => store.user)
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const { slug } = useParams<{ slug: string }>()
  const PrivateValidationFragment = <Outlet />

  // Excepción temporal, solo para WOM: el ACS del SSO todavía no resuelve el usuario en
  // la BD y devuelve id 0, así que se valida por sesión federada en vez de por id.
  // Cuando el ACS devuelva el id real, esto se borra y queda solo `userState.id > 0`.
  const isWomSsoSession = configSeller.config?.s3?.FOLDER_APP === 'ti_wom' && userState.sso === true
  const isIdentified = userState.id > 0 || isWomSsoSession

  return isIdentified && roles.includes(userState.id_role) ? PrivateValidationFragment : <Navigate replace to={PublicRoutes.LOGIN.replace(':slug', String(slug))} />
}

export default AuthRoleRouterGuard
